export default function PageLoadingSpinner() {
  return (
    <div className="flex items-center justify-center" style={{ minHeight: '50vh' }}>
      <div
        className="animate-spin rounded-full h-8 w-8 border-2 border-t-transparent"
        style={{ borderColor: 'var(--border-color)', borderTopColor: 'var(--color-accent)' }}
      />
    </div>
  )
}
